import styled from 'styled-components';
import { Scalars } from '@bechtel/types';

export const StatsContainerStyled = styled.div`
  padding-left: ${({ theme }) => theme.spacings[600]};
  padding-right: ${({ theme }) => theme.spacings[600]};
  margin-bottom: ${({ theme }) => theme.spacings[400]};
`;

export const StatsBlockStyled = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey[300]};
  border-radius: ${({ theme }) => theme.radii[200]};
  padding-left: ${({ theme }) => theme.spacings[500]};
  padding-right: ${({ theme }) => theme.spacings[500]};
  padding-top: ${({ theme }) => theme.spacings[300]};
  padding-bottom: ${({ theme }) => theme.spacings[300]};
`;

export const StatsListStyled = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > * {
    border-right: 1px solid ${({ theme }) => theme.colors.grey[300]};
  }

  & > :last-child {
    border-right: none;
  }
`;

interface ProgressBarContainerStyledProps {
  isSecondaryOwnersAssigned: Scalars['Boolean'];
  canEditOwnership: Scalars['Boolean'];
}

function getProgressBarRightPadding({ isSecondaryOwnersAssigned, canEditOwnership }) {
  let padding = 0;
  if (isSecondaryOwnersAssigned) padding = 166;
  if (canEditOwnership) padding += 133;
  return `${padding}px`;
}

export const ProgressBarContainerStyled = styled.div<ProgressBarContainerStyledProps>`
  padding-right: ${getProgressBarRightPadding};
  margin-bottom: ${({ theme }) => theme.spacings[400]};
`;
